import { useState } from "react";
import { getUno } from "../../api/apis";

export const useMotivosDesvinculacion = () => {
  const [motivos, setMotivos] = useState([]);

  const traerMotivos = async () => {
    const resp = await getUno('listadoclasulasdespido', null, null);
    setMotivos(resp.data.data);
  }

  return {
    motivos, traerMotivos
  }
}